import React from "react";

const MainContentWidthContext = React.createContext("0");

export const MainContentWidthProvider = MainContentWidthContext.Provider;
export default MainContentWidthContext;
